import type {
  InvitePlatformAdminRequest,
  InvitePlatformAdminResponse,
  ListInvitationsResponse,
  PlatformSuperAdminListResponse,
  ResendInvitationResponse,
  SetPlatformAdminActiveResponse,
} from '@jq4race/shared';

import { request } from './client.js';

// ── Platform team — super_admin inviting/managing other super_admins ────────

/** POST /super-admin/team/invitations — invites another super_admin (role is implicit). */
export async function invitePlatformAdmin(
  input: InvitePlatformAdminRequest,
): Promise<InvitePlatformAdminResponse> {
  return request<InvitePlatformAdminResponse>('/super-admin/team/invitations', {
    method: 'POST',
    body: input,
  });
}

/** GET /super-admin/team/invitations — lists platform-level (org-less) invitations. */
export async function listPlatformInvitations(): Promise<ListInvitationsResponse> {
  return request<ListInvitationsResponse>('/super-admin/team/invitations', { method: 'GET' });
}

/** POST /super-admin/team/invitations/:id/resend — resends a platform super_admin invitation. */
export async function resendPlatformInvitation(
  invitationId: string,
): Promise<ResendInvitationResponse> {
  return request<ResendInvitationResponse>(
    `/super-admin/team/invitations/${encodeURIComponent(invitationId)}/resend`,
    { method: 'POST' },
  );
}

/** GET /super-admin/team/members — lists platform super_admins. */
export async function listPlatformSuperAdmins(): Promise<PlatformSuperAdminListResponse> {
  return request<PlatformSuperAdminListResponse>('/super-admin/team/members', { method: 'GET' });
}

/** PATCH /super-admin/team/members/:id — deactivates or reactivates a platform super_admin. */
export async function setPlatformAdminActive(
  userId: string,
  active: boolean,
): Promise<SetPlatformAdminActiveResponse> {
  return request<SetPlatformAdminActiveResponse>(
    `/super-admin/team/members/${encodeURIComponent(userId)}`,
    { method: 'PATCH', body: { active } },
  );
}
